import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../atoms/BaseButton';
import FullScreenDialog from '../../molecules/FullScreenDialog';
import MonthlyClosingForm from './MonthlyClosingForm';
import { useNotify } from '../../../hooks/notificationHook';
var MonthlyClosingButton = function (_a) {
    var onSuccess = _a.onSuccess;
    var t = useTranslation().t;
    var notify = useNotify();
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var handleOpen = React.useCallback(function () { return setOpen(true); }, []);
    var handleClose = React.useCallback(function () { return setOpen(false); }, []);
    var handleSubmit = React.useCallback(function (monthlyClosing) {
        notify('success', [
            t('messages.createdInvoices', {
                count: monthlyClosing.invoices.length,
            }),
        ]);
        setOpen(false);
        onSuccess(monthlyClosing);
    }, [t, notify, onSuccess]);
    return (React.createElement("div", null,
        React.createElement(Button, { onClick: handleOpen }, t('pages.monthlyClosing.createButton')),
        React.createElement(FullScreenDialog, { title: t('pages.monthlyClosing.createButton'), open: open, onClose: handleClose },
            React.createElement(MonthlyClosingForm, { onSubmit: handleSubmit }))));
};
export default MonthlyClosingButton;
